import ColumnSelector from './ColumnSelector';

export default ColumnSelector;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/ColumnSelector/index.js